import { useState } from "react";
import { uploadFileViaPresignedPost } from "../../../../../utils/presignedUpload";

export const useUploadFile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isUploadedFile, setIsUploadedFile] = useState(false);

  const handleUploadFile = async (file) => {
    setError(null);
    setIsUploadedFile(false);

    if (!file) {
      setError("No se selecciono un archivo");
      return null;
    }

    setIsLoading(true);

    try {
      // Upload straight to S3 via a presigned POST — the binary no longer
      // travels through the backend.
      const { url } = await uploadFileViaPresignedPost(file, {
        folder: "broadcast",
      });

      setIsUploadedFile(true);
      return url;
    } catch (e) {
      setError("Error al subir el archivo");
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleUploadFile,
    isLoading,
    error,
    isUploadedFile,
  };
};
